import {
  URL_CAMBIO_GRUPO,
  URL_MARKETING,
  URL_PRODUCTO_MIRANDA,
  URL_PRODUCTO_VENTA,
  URL_STOCK
} from "../../../api/config";
import makeQuery, {cleanObj} from "../../../api/helper";


export default {
  namespaced: true,
  state: {
    productos: [],
    isLoading: false,
    filtros: {
      codigo: "",
      descripcion: "",
      codigo_proveedor: "",
      numero_parte: "",
      medida: "",
      estado: ""
    },
    currentPage: 1,
    limite: 15,
    offset: 0
  },
  mutations: {
    "SET_PRODUCTOS"(state, payload) {
      state.productos = payload
    },
    "SET_FILTROS"({filtros}, payload) {
      filtros[payload.key] = payload.value
    },
    "SET_LOADING"(state, payload) {
      state.isLoading = payload
    },
    "NEXT_PAGE"(state) {
      state.currentPage++
      state.offset = state.limite * (state.currentPage - 1)
    },
    "BACK_PAGE"(state) {
      state.currentPage--
      state.offset = state.limite * (state.currentPage - 1)
    },
    "RESET_PAGES"(state) {
      state.limite = 15
      state.offset = 0
      state.currentPage = 1
    },
    "REMOVE_CODIGO_PROVEEDOR"(state, payload) {
      state.productos[payload.index].codigo_proveedor.splice(payload.indexProducto, 1)
    },
    "FILTRO_CODIGO_PROVEEDOR"(state) {
      state.filtros.codigo = undefined
      state.filtros.descripcion = undefined
      state.filtros.numero_parte = undefined
      state.filtros.medida = undefined
      state.filtros.estado = ""
    }
  },
  actions: {
    async getProductos({dispatch}) {
      dispatch("sendRequest")
    },
    async sendRequest({commit, dispatch, state}) {
      commit("SET_LOADING", true)
      try {
        let data
        const query = await dispatch("createQuery")
        if (state.filtros.codigo_proveedor !== undefined) data = await this._vm.$axios.get(`${URL_PRODUCTO_VENTA}/${state.filtros.codigo_proveedor + query}`)
        else data = await this._vm.$axios.get(`${URL_PRODUCTO_VENTA + query}&ordenar_por=codigo&orden=asc`)
        commit("SET_PRODUCTOS", data.data.items.map(item => ({
          ...item,
          precio: item.precio.precio,
          stock: item.stock_venta,
          ubicacion: item.stock_venta.find(s => s.sucursal_id === window.localStorage.sucursal_id).ubicacion,
        })))
        commit("SET_LOADING", false)
      } catch (e) {
        commit("SET_LOADING", false)
        console.log(e)
      }
    },
    createQuery({state}) {
      const descripcion = state.filtros.descripcion ? state.filtros.descripcion.split(" ").map(item => {
        return {field: 'descripcion', value: item, operator: 'CONTAINS'}
      }) : ""
      let filtros = []
      const newObj = cleanObj(state.filtros)
      Object.keys(newObj).forEach(item => {
        if (item === "descripcion") filtros.push(...descripcion)
        else filtros.push({field: item, value: newObj[item], operator: "CONTAINS"})
      })
      filtros = state.filtros.codigo_proveedor !== undefined ?
        filtros.filter(item => item.field !== "codigo_proveedor") : filtros
      return makeQuery({
        filtros,
        limite: state.limite,
        offset: state.offset
      })
    },
    async eliminarProducto(context, payload) {
      const resp = await this._vm.$swal({
        type: 'warning',
        text: '¿Está seguro que desea desactivar el producto?',
        title: 'Desactivacion de producto',
        html: ` <small>(Esta Eliminación solo cambia el estado del producto para que no pueda ser vendido)</small>`,
        confirmButtonColor: 'blue',
        cancelButtonText: 'No!',
        showCancelButton: true,
        cancelButtonColor: 'red',
        confirmButtonText: 'Si',
      })
      if (!resp.value || resp.value !== true) return
      console.log(payload)
      return new Promise((resolve, reject) => {
        this._vm.$axios.put(URL_PRODUCTO_MIRANDA, {
          ...payload,
          id: payload.producto_id,
          numeroParte: payload.numero_parte,
          productoMedida: payload.productoMedida,
          productoPais: payload.productoPais,
          productoObservacion: payload.productoObservacion,
          vehiculosCompatibles: payload.vehiculosCompatibles,
          codigos_proveedor: payload.codigo_proveedor,
          estado: 'inactivo',
          usuario: {
            nombre: window.localStorage.nombre,
            id: window.localStorage.usuario_id
          }
        }).then(resolve)
          .catch(reject)
      })
    },
    async cambiarGrupo(context, payload) {
      const resp = await this._vm.$swal({
        type: 'warning',
        text: '¿Está seguro que desea cambiar el grupo?',
        title: 'Cambiar Grupo',
        confirmButtonColor: 'blue',
        cancelButtonText: 'No!',
        showCancelButton: true,
        cancelButtonColor: 'red',
        confirmButtonText: 'Si',
      })
      if (!resp.value || resp.value !== true) return
      try {
        const response = await this._vm.$axios.put(`${URL_CAMBIO_GRUPO}/${payload.id}`, {
          grupo: payload.grupo.toUpperCase(),
          usuario: {nombre: window.localStorage.nombre, id: window.localStorage.usuario_id}
        })
        if (response.status === 201) {
          this._vm.$swal("Correcto!", "Grupo cambiado correctamente...", "success")
        }
      } catch (e) {
        console.log(e)
        this._vm.$swal("Error!", e, "error")
      }
    },
    async eliminarCodigoProveedor(context, payload) {
      const resp = await this._vm.$swal({
        type: 'warning',
        text: '¿Está seguro que desea eliminar el codigo de proveedor?',
        title: 'Eliminar Codigo Proveedor',
        confirmButtonColor: 'blue',
        cancelButtonText: 'No!',
        showCancelButton: true,
        cancelButtonColor: 'red',
        confirmButtonText: 'Si'
      })
      if (resp.value !== true) return
      return new Promise(((resolve, reject) => {
        this._vm.$axios.put(`${URL_PRODUCTO_MIRANDA}/codigo-proveedor`, {
          usuario: {
            nombre: window.localStorage.nombre,
            id: window.localStorage.usuario_id
          },
          id: payload.producto_id,
          codigoProveedor: payload.codigoProveedor,
          idProveedor: payload.proveedorId
        }).then(response => resolve(response))
          .catch(error => reject(error))
      }))
    },
    nextPage({commit, dispatch}) {
      commit("NEXT_PAGE")
      dispatch("getProductos")
    },
    backPage({commit, dispatch}) {
      commit("BACK_PAGE")
      dispatch("getProductos")
    },
    resetPages({commit, dispatch}) {
      commit("RESET_PAGES")
      dispatch("getProductos")
    },
  },
  getters: {
    productos: state => state.productos,
    isLoading: state => state.isLoading,
    currentPage: state => state.currentPage
  }
}
